import { Injectable } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Configuration, BaseClass } from './../../app.constants';


export class BankDetails
{
  StudentID:number;
  BankName: string
  BankBranchName: string
  IFSCCode: string
  AccountNo: string

  NomineeName:string;
  NomineeRelation:string;
  NomineeBirthDate:string;
  NomineeAge:number;

  TenthCETMark:number;
  TenthCETMarkDocPath:string='';
}

@Injectable({
  providedIn: 'root'
})
export class BankdetailsformService {

  constructor(
    private http: HttpClient,
    private configuration : Configuration,private dataService: DataAccessService) { }
  getGridColumnsData() {
    return BankDetails[0];
  } 
  public update(data) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostBankDetails'; 
    return this.dataService.add<BankDetails[]>(data) 
  }
  public updateTenthCETMark(data) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostTenthCETMarkDetails'; 
    return this.dataService.add<BankDetails[]>(data) 
  }
  public GetBankDetail(StudentID) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetBankDetails?StudentID='+StudentID;  
    return this.dataService.getAll<BankDetails[]>()
  }
  public GetTenthCETMarkDetail(StudentID) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetTenthCETMarkDetail?StudentID='+StudentID;  
    return this.dataService.getAll<BankDetails[]>()
  }
  uploadDocFile(fileToUpload: File,StudentID) {debugger
    let formData: FormData = new FormData(); 
  
             formData.append('file', fileToUpload, fileToUpload.name); 
            var queryParam="?StudentID=" + StudentID + "";
            let apiUrl = this.configuration.serverWithApiUrl +"/PreStudentEnrolment/PostuploadTenthMarkSheet" + queryParam;
  
            return this.http
            .post(apiUrl, formData);
    }
}
